import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import ScrollToTop from './component/scrollToTop/ScrollToTop';
import WhatsAppButton from './elements/whatsapp/WhatsAppButton';
import CookieConsent from './elements/cookie/CookieConsent';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
// Initialize Firebase
import './data/firebase/FirebaseConfig';
import 'bootstrap/dist/css/bootstrap.min.css';


// Home Page - Corporate Agency Template
import CorporateAgency from './pages/CorporateAgency';

// Main Pages
import AboutUs from './pages/AboutUs';
import CaseStudy from './pages/CaseStudy';
import ServiceOne from './pages/ServiceOne';
import Contact from './pages/Contact';

// Additional Pages (kept for functionality)
import ErrorPage from './pages/404';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

// Css Import
import './assets/scss/app.scss';


const App = () => {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop>
            <Routes>
              {/* Main Routes - Portuguese */}
              <Route path="/" element={<CorporateAgency />}/>
              <Route path="/sobre-nos" element={<AboutUs />}/>
              <Route path="/dicas" element={<CaseStudy />}/>
              <Route path="/servicos" element={<ServiceOne />}/>
              <Route path="/contactos" element={<Contact />}/>

              {/* Additional Pages */}
              <Route path="/404" element={<ErrorPage />}/>
              <Route path="/politica-de-privacidade" element={<PrivacyPolicy />}/>
              <Route path="/termos-de-uso" element={<TermsOfUse />}/>

              {/* Catch-all route for 404 - must be last */}
              <Route path="*" element={<ErrorPage />}/>

            </Routes>
            <WhatsAppButton />
            <CookieConsent />
          </ScrollToTop>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  )
}

export default App;
